module.exports = __webpack_public_path__ + "static/media/overwatch.f03be4c6.jpg";